import React from 'react'
import NumberFormat from 'react-number-format'
import { validation, validateCase as vCase } from 'core/validate'

export const numberFormat = (value, allowNegative = false, decimalScale = 2) => {
  return (
    <NumberFormat
      className='centerContent'
      thousandSeparator=','
      value={value}
      displayType='text'
      decimalScale={decimalScale}
      allowNegative={allowNegative}
      fixedDecimalScale />
  )
}

export const calculateTotalAmount = (items, change, isSumOnly = false) => {
  var total = 0
  items.map(i => total = total + (!i.deleted ? (i.quantity * i.unitPrice) : 0))
  if (change) change('totalAmount', total)

  if (!isSumOnly) return numberFormat(total)
}

export const calculateVat = (items, vat, change, isSumOnly = false) => {
  let vatAmount = 0
  items.map(i => vatAmount = vatAmount + (!i.deleted ? ((i.quantity * i.unitPrice) / 100) : 0) * vat)
  if (change) change('vatAmount', vatAmount)

  if (!isSumOnly) return numberFormat(vatAmount)
}

export const calculateTotalIncludeVat = (items, vat, change, isSumOnly = false) => {
  let total = 0
  items.map(i => total = total + ((!i.deleted ? (i.quantity * i.unitPrice) : 0) + ((!i.deleted ? ((i.quantity * i.unitPrice) / 100) : 0) * vat)))
  if (change) change('totalAmountIncludeVat', total)

  if (!isSumOnly) return numberFormat(total)
}

export const getOptionTitle = (options, value, displayWithValue = true) => {
  if (value !== undefined) {
    const opt = options && options.find(o => o.value === value)
    let result = opt ? opt.text : value
    // return displayWithValue ? result : result.replace(`${value} : `, '')
    return displayWithValue ? result : result.split(':')[0]
  } else {
    return ''
  }
}

export const validateAttachments = (values) => {
  const errors = []
  values.documentTypes.forEach((dt) => {
    if (values.isAdditionalPr === dt.isAdditional) {
      const code = dt.code.toLowerCase()
      if (dt.isRequire) {
        let docValue = values[code]
        if (docValue) {
          if (!docValue.length) {
            errors.push({ fieldName: dt.name, message: 'Required!' })
          }
        } else {
          const checkDoc = values.rfqAttachments.filter(a => a.documentTypeCode.toLowerCase() === code && !a.deleted)
          if (!checkDoc.length) {
            errors.push({ fieldName: dt.name, message: 'Required!' })
          }
        }
      }
    }
  })
  return errors
}

export const validateQuotationAttachments = (oldAttachments, newAttachments) => {
  var validate = true
  oldAttachments.forEach(x => {
    if (!x.fileItems.length) {
      let newI = newAttachments ? newAttachments[`v${x.vendorCode}|${x.rfqSapNumber}`] : null
      if (newI) {
        validate = validate ? newI.length > 0 : false
      } else {
        validate = false
      }
    } else {
      let fileDeleted = x.fileItems.filter(x => x.deleted === true)
      let allDelete = (fileDeleted.length === x.fileItems.length)
      if (allDelete) {
        let newI = newAttachments ? newAttachments[`v${x.vendorCode}|${x.rfqSapNumber}`] : null
        if (newI) {
          validate = validate ? newI.length > 0 : false
        } else {
          validate = false
        }
      }
    }
  })
  return validate
}

export const validateField = (values) => {
  let errors = {}
  errors = validation(values, 'title', [vCase.require, vCase.maxLength200], errors)
  if (!values.requesterUser) {
    errors.requesterUser = 'Required!'
  }
  if (!values.documentDate) {
    errors.documentDate = 'Required!'
  }
  if (!values.collectiveNumber) {
    errors.collectiveNumber = 'Required!'
  }
  if (!values.category) {
    errors.category = 'Required!'
  }
  if (!values.goaItemCode) {
    errors.goaItemCode = 'Required!'
  }
  if (!values.priority) {
    errors.priority = 'Required!'
  }
  if (values.isAdditionalPr) {
    errors = validation(values, 'additionalRefPoNumber', [vCase.integer, vCase.require, vCase.maxLength10], errors)
  }
  let vendorSelectIndex = values.rfqItemVendorTotalAmounts ? values.rfqItemVendorTotalAmounts.findIndex(x => x.isVendorSelected === true) : -1
  let vendorSelect = vendorSelectIndex >= 0 ? values.rfqItemVendorTotalAmounts[vendorSelectIndex] : null
  if (vendorSelect && vendorSelect.discount) {
    if (vendorSelect.discount > vendorSelect.totalBeforeDiscount) {
      if (!errors.rfqItemVendorTotalAmounts) errors.rfqItemVendorTotalAmounts = new Array(values.rfqItemVendorTotalAmounts.length)
      errors.rfqItemVendorTotalAmounts[vendorSelectIndex] = { discount: 'Required!' }
    }
  }
  if (values.isAdditionalPr) {
    if (!values.additionalPrReason ? true : !values.additionalPrReason.trim()) {
      errors.additionalPrReason = 'Required!'
    } if (!values.additionalRefPoNumber ? true : !values.additionalRefPoNumber.trim()) {
      errors.additionalRefPoNumber = 'Required!'
    }
  } else {
    values.additionalPrReason = ''
    values.additionalRefPoNumber = ''
    values.additionalContractNumber = ''
  }
  if (values.isSpecialPr) {
    if (!values.specialPrTitle ? true : !values.specialPrTitle.trim()) {
      //errors.specialPrTitle = 'Required!'
    } if (!values.specialPrReason ? true : !values.specialPrReason.trim()) {
      errors.specialPrReason = 'Required!'
    }
  } else {
    values.specialPrTitle = ''
    values.specialPrReason = ''
    values.specialPrVendorName = ''
  }
  if (values.stampDutyType === undefined || values.stampDutyType === null || values.stampDutyType === '') {
    errors.stampDutyType = 'Required!'
  }

  if (values.bargained === null || values.bargained === undefined) {
    errors.bargained = 'Required!'
  } else {
    if (values.bargainRemark === null || values.bargainRemark === undefined || values.bargainRemark === '') {
      errors.bargainRemark = 'Required!'
    }

    if (values.bargained) {
      var rfq04Files = (values.rfqAttachments || []).filter(x => x.documentTypeCode.toLowerCase() === 'rfq04' && !x.deleted) || []
      if ((values.rfq04 || []).length === 0 && rfq04Files.length === 0) {
        errors.rfq04 = 'Required!'
      }
    }
  }
  return errors
}
